/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Icd10Code
 */
export interface Icd10Code {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    code: string;
    /**
     * 
     */
    short_description: string;
    /**
     * 
     */
    is_snf_primary_ineligible: boolean;
}

/**
 * Check if a given object implements the Icd10Code interface.
 */
export function instanceOfIcd10Code(value: object): value is Icd10Code {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('short_description' in value) || value['short_description'] === undefined) return false;
    if (!('is_snf_primary_ineligible' in value) || value['is_snf_primary_ineligible'] === undefined) return false;
    return true;
}

export function Icd10CodeFromJSON(json: any): Icd10Code {
    return Icd10CodeFromJSONTyped(json, false);
}

export function Icd10CodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Icd10Code {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'short_description': json['short_description'],
        'is_snf_primary_ineligible': json['is_snf_primary_ineligible'],
    };
}

export function Icd10CodeToJSON(json: any): Icd10Code {
    return Icd10CodeToJSONTyped(json, false);
}

export function Icd10CodeToJSONTyped(value?: Icd10Code | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'short_description': value['short_description'],
        'is_snf_primary_ineligible': value['is_snf_primary_ineligible'],
    };
}

